import { render, staticRenderFns } from "./analysisDetails.vue?vue&type=template&id=2b4bcc5a&scoped=true"
import script from "./analysisDetails.vue?vue&type=script&lang=js"
export * from "./analysisDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4bcc5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4bcc5a')) {
      api.createRecord('2b4bcc5a', component.options)
    } else {
      api.reload('2b4bcc5a', component.options)
    }
    module.hot.accept("./analysisDetails.vue?vue&type=template&id=2b4bcc5a&scoped=true", function () {
      api.rerender('2b4bcc5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory/sensory-calibration/analysisDetails.vue"
export default component.exports